var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "45F5F6F9-B3BC-45F5-A3F6-83D107780D3D")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "77.1789382%",
    cy: "28.2953398%",
    fx: "77.1789382%",
    fy: "28.2953398%",
    r: "92.1088703%",
    gradientTransform: "translate(0.771789,0.282953),scale(0.649667,1.000000),rotate(139.001368),scale(1.000000,0.549253),translate(-0.771789,-0.282953)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A00CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212529",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "36.5759181%",
    cy: "6.04156562%",
    fx: "36.5759181%",
    fy: "6.04156562%",
    r: "102.937108%",
    gradientTransform: "translate(0.365759,0.060416),scale(0.649667,1.000000),rotate(43.961666),scale(1.000000,0.435949),translate(-0.365759,-0.060416)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E1FF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 902,
    height: 586,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 0,
    width: 343,
    height: 52,
    rx: 22
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.4%",
    y: "-28.8%",
    width: "112.8%",
    height: "215.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7,
    operator: "erode",
    "in": "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 23,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.597854393   0 0 0 0 0.247059147  0 0 0 0.240757655 0",
    type: "matrix",
    "in": "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Referral-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3-Referral---user-account",
    transform: "translate(-1090.000000, -851.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1680,
    height: 1699
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(578.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-2)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(276.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Share",
    transform: "translate(236.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,9.8 C15.5581715,9.8 15.1999993,9.4418278 15.1999993,9 C15.1999993,8.5581722 15.5581715,8.2 16,8.2 L16.7999992,8.2 C18.5673103,8.2 20,9.6326888 20,11.4 L20,17.8 C20,19.5673112 18.5673103,21 16.7999992,21 L7.19999981,21 C5.43268872,21 4,19.5673112 4,17.8 L4,11.3944455 C4,9.62713432 5.43268872,8.19444552 7.19999981,8.19444552 L8,8.19444552 C8.44183139,8.19444552 8.80000357,8.55261772 8.80000357,8.99444552 C8.80000357,9.43627332 8.44183139,9.79444552 8,9.79444552 L7.19999981,9.79444552 C6.31634426,9.79444552 5.5999999,10.5107899 5.5999999,11.3944455 L5.5999999,17.8 C5.5999999,18.6836556 6.31634426,19.4 7.19999981,19.4 L16.7999992,19.4 C17.6836548,19.4 18.3999991,18.6836556 18.3999991,17.8 L18.3999991,11.4 C18.3999991,10.5163444 17.6836548,9.8 16.7999992,9.8 L16,9.8 Z",
    id: "Path-103",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4696699,3.23431458 C11.7625631,2.92189514 12.2374369,2.92189514 12.5303301,3.23431458 L12.5303301,3.23431458 L14.7803301,5.63431458 C15.0732233,5.94673401 15.0732233,6.45326599 14.7803301,6.76568542 C14.4874369,7.07810486 14.0125631,7.07810486 13.7196699,6.76568542 L13.7196699,6.76568542 L12.798,5.782 L12.7999995,5.79999995 L12.7999995,13.8 C12.7999995,14.2418278 12.4418273,14.6 11.9999995,14.6 C11.5581717,14.6 11.1999996,14.2418278 11.1999996,13.8 L11.1999996,13.8 L11.1999996,5.79999995 C11.1999996,5.79490194 11.2000473,5.78981506 11.2001422,5.78473975 L10.2803301,6.76568542 C9.98743687,7.07810486 9.51256313,7.07810486 9.21966991,6.76568542 C8.9267767,6.45326599 8.9267767,5.94673401 9.21966991,5.63431458 L9.21966991,5.63431458 Z",
    id: "Combined-Shape",
    fill: "#212529"
  }))))))));
};
export default SvgShare;